import {HttpService} from './http.service';
import {Injectable} from '@angular/core';

import {environment} from '../../../environments/environment';

const REVIEW_ACTION = require('../../../../../server/shared/constants/review-action.constant');
const status = require('../../../../../server/shared/constants/status.constant');

@Injectable()
export class ParticipationFormService {

  constructor(private http: HttpService) {
  }

  getParticipationForms(includeDeleted: boolean = false) {
    const query = includeDeleted ? '?includeDeleted=true' : '';
    return this.http.get(`${environment.SERVER_URL}/participationForm/${query}`);
  }

  getParticipationFormDraft() {
    return this.http.get(`${environment.SERVER_URL}/participationForm/draft`);
  }

  upsert(formSubmissionCode) {
    return this.http.post(`${environment.SERVER_URL}/participationForm/save/${formSubmissionCode}`, {});
  }

  upsertCleanup(formSubmissionCode) {
    return this.http.post(`${environment.SERVER_URL}/participationForm/save/${formSubmissionCode}/cleanup`, {});
  }

  approve(formSubmissionCode, comments) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/action/${REVIEW_ACTION.APPROVE}`,
      {comments: comments});
  }

  decline(formSubmissionCode, comments) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/action/${REVIEW_ACTION.DECLINE}`,
      {comments: comments});
  }

  returnApplication(formSubmissionCode, comments) {
    return this.http.put(
      `${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/action/${REVIEW_ACTION.RETURN_APPLICATION}`,
      {comments: comments});
  }

  amendApplication(previousSubmissionCode, nextSubmissionCode, amendWithWF) {
    const action = amendWithWF ? REVIEW_ACTION.AMEND_WITH_WORKFLOW : REVIEW_ACTION.AMEND;
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${previousSubmissionCode}/action/${action}`,
      {nextSubmissionCode: nextSubmissionCode});
  }

  saveProgramName(formSubmissionCode, programLocation, programNumber) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/program`, {
      programLocation: programLocation,
      programNumber: programNumber
    });
  }

  updateRestrictedSiteAccess(formSubmissionCode, access) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/restricted-site`, {access});
  }

  updateIndividualRestrictedSiteAccess(formSubmissionCode, access) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/individual-restricted-site`,
      {access});
  }

  generateProgramName(formSubmissionCode) {
    return this.http.get(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/program`);
  }

  emailSupplier(formSubmissionCode) {
    return this.http.put(
      // tslint:disable-next-line:max-line-length
      `${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/action/${status.PENDING_VENDOR_ACCOUNT_CREATION.name}/emailSupplier`,
      {});
  }

  inactivateParticipationForm(formSubmissionCode) {
    // tslint:disable-next-line:max-line-length
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/action/${status.INACTIVATED.name}/inactivate`,
      {});
  }

  enableOrdering(formSubmissionCode) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/enableOrdering`, {});
  }

  getBySubmissionCode(formSubmissionCode) {
    return this.http.get(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}`);
  }

  getBySubmissionCodeCleanup(formSubmissionCode, cleanupInProgress) {
    return this.http.put(`${environment.SERVER_URL}/participationForm/submission/${formSubmissionCode}/cleanup/${cleanupInProgress}`, {});
  }

  exportEmployeePayrollTitles() {
    return this.http.get(`${environment.SERVER_URL}/participationForm/export-employee-payroll-titles`, {});
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/participation-form.service.ts